import { Button, Drawer, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { auto } from "@popperjs/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RightChevron } from "../../../common/js/icons";
import { formatDateToDisplay } from "../utils/operations";

// Header of the comment section
const StyledCommentHeader = styled("div")(() => ({
    paddingTop: "20px",
}));

// StyledExit (probably an icon or button)
const StyledExit = styled("div")(() => ({
    "&:hover": {
        cursor: "pointer",
    },
}));

// Container for a comment
const StyledCommentContainer = styled("div")(() => ({
    padding: "20px 0 0",
    marginTop: "15px",
    marginBottom: "12px",
    borderTop: "1px solid #ededed",
}));

// Name and date (can reuse the same if needed)
const StyledCommentName = styled("div")(() => ({
    fontSize: 12,
    paddingBottom: "20px",
}));

const StyledCommentDate = styled("div")(() => ({
    fontSize: 12,
    paddingBottom: "20px",
}));

// Container styles to replace Grid
const StyledFlexContainer = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",
    boxSizing: "border-box",
}));

const StyledFlexEnd = styled("div")(() => ({
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    width: "100%",
}));

const StyledFlexStart = styled("div")(() => ({
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
}));

const StyledFullWidthDiv = styled("div")(() => ({
    width: "100%",
    overflowY: "auto",
}));

const StyledDrawer = styled(Drawer)(() => ({
    "& .MuiDrawer-paper": {
        padding: "0 20px",
        display: "block",
        transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
        maxWidth: "26rem",
        left: auto,
        right: 0,
    },
}));

const Comments = (props) => {
    const {
        commentDraft,
        disabled,
        handleSubmitComment,
        handleClearComment,
        handleChange,
        toggleComments,
        comments,
        open,
        parentRecordType,
        parentRecordId,
        handleRequestUpdate,
        redirectTo,
        showRequestUpdateListing,
        showSubmitListing,
        setRequestUpdateAndSubmit,
        listing,
        userProfile,
    } = props;

    useEffect(() => {
        if (setRequestUpdateAndSubmit) setRequestUpdateAndSubmit(listing, userProfile);
    }, [listing]);

    const showRequestUpdateButton =
        showRequestUpdateListing !== undefined
            ? showRequestUpdateListing
            : parentRecordType === "property"
            ? true
            : false;

    const navigate = useNavigate();

    const showSubmitButton = showSubmitListing !== undefined ? showSubmitListing : true;

    const requestUpdate = async () => {
        const result = await handleRequestUpdate(parentRecordType, parentRecordId);
        if (result.success) {
            if (parentRecordType.toLowerCase() === "listing") {
                navigate(redirectTo ? redirectTo : `/listing/${parentRecordId}`);
            } else if (parentRecordType.toLowerCase() === "property") {
                navigate(redirectTo ? redirectTo : `/property/${parentRecordId}`);
            }
        }
    };

    return (
        <StyledDrawer anchor="right" open={open} onClose={toggleComments}>
            <StyledFlexContainer>
                <StyledCommentHeader>
                    <h3>Comments ({comments.length})</h3>
                </StyledCommentHeader>
                <div>
                    <StyledExit role="button" onClick={toggleComments}>
                        <RightChevron />
                    </StyledExit>
                </div>
                {showRequestUpdateButton || showSubmitButton ? (
                    <div style={{ fontSize: "14px" }}>
                        After typing your comment,{" "}
                        {showRequestUpdateButton && 'click "Request Update" to send to the Corporate Data Team'}
                        {showRequestUpdateButton && showSubmitButton && " or "}
                        {showSubmitButton && 'click "Submit" to add a standard comment'}.
                    </div>
                ) : (
                    ""
                )}
            </StyledFlexContainer>
            <StyledFullWidthDiv>
                <TextField
                    id="outlined-textarea"
                    placeholder="Write your comment here..."
                    multiline
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    onChange={handleChange}
                    value={commentDraft}
                    maxRows={25}
                />
            </StyledFullWidthDiv>
            <StyledFlexEnd>
                <div>
                    <Button onClick={handleClearComment} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </div>
                {showRequestUpdateButton && (
                    <div>
                        <Button onClick={requestUpdate} variant="contained" color="secondary" disabled={disabled}>
                            Request Update
                        </Button>
                    </div>
                )}
                {showSubmitButton && (
                    <div>
                        <Button
                            onClick={(e) => handleSubmitComment(parentRecordType, parentRecordId)}
                            variant="contained"
                            color="primary"
                            disabled={disabled}
                        >
                            Submit
                        </Button>
                    </div>
                )}
            </StyledFlexEnd>
            {comments.map((c, i) => (
                <StyledCommentContainer key={`${parentRecordType}-comment-${i}`}>
                    <StyledFlexContainer>
                        <div>
                            <StyledCommentName>{c.auditCreatedBy}</StyledCommentName>
                        </div>
                        <div>
                            <StyledCommentDate>
                                posted on {formatDateToDisplay(c.auditCreatedTimestamp)}
                            </StyledCommentDate>
                        </div>
                    </StyledFlexContainer>
                    <StyledFlexStart>
                        <div>
                            <div key={`comment-${i}`}>{c.comment}</div>
                        </div>
                    </StyledFlexStart>
                </StyledCommentContainer>
            ))}
            <br />
            &nbsp;
        </StyledDrawer>
    );
};

export default Comments;
